import React, { Component } from 'react';
import ClientForm from 'components/admin/clients/ClientForm';
import { connect } from 'react-redux';
import { updateClientData } from 'actions/admin/clients/clients';
import { getCurrentClient } from 'selectors/admin/clients/clients';
import { loadClientRequest } from 'actions/admin/clients/clients';
import numeral from 'numeral';

class EditClient extends Component {
  constructor(props) {
    super(props);
    this.clientId = numeral(props.match.params.id).value();
  }

  handleOnSubmit = (values) => {
    this.props.dispatch(updateClientData(this.clientId, values));
  };

  UNSAFE_componentWillMount() {
    if (this.props.client === null || this.props.client.id !== this.clientId) {
      this.props.dispatch(loadClientRequest(this.clientId));
    }
  }

  render() {
    let client = this.props.client;
    if (client) {
      this.initialValues = {
        id: client.id,
        name: client.company_name,
        firstName: client.contact.first_name,
        lastName: client.contact.last_name,
        email: client.contact.email,
        phoneNumber: client.contact.phone_number,
        clientLogo: client.logo,
      };
      if (client.location) {
        this.initialValues['streetAddress'] = client.location.street_address_1;
        this.initialValues['unitNumber'] = client.location.street_address_2;
        this.initialValues['city'] = client.location.city;
        this.initialValues['state'] = client.location.state;
        this.initialValues['zipCode'] = client.location.zip;
      }
    }

    return (
      <div>
        {client && (
          <ClientForm
            initialValues={this.initialValues}
            onSubmit={this.handleOnSubmit}
          />
        )}
      </div>
    );
  }
}
export default connect((state) => {
  return {
    client: getCurrentClient(state),
  };
})(EditClient);



// WEBPACK FOOTER //
// ./src/components/admin/clients/EditClient.js